@if (anchor) {
  <a [id]="anchor"></a>
}

<kb-flipping-tiles [variant]="attributes.variant ?? 'tile-primary'">
  @if (attributes.headline) {
    <h2 kb-heading [appEditorId]="editorIds?.headline">{{ attributes.headline }}</h2>
  }

  @if (attributes.content) {
    <kb-html [appEditorId]="editorIds?.content" [html]="attributes.content"></kb-html>
  }

  @for (item of attributes.items; track item) {
    <kb-flipping-tile [appEditorId]="item.editorId">
      @if (item.attributes.image) {
        <kb-picture
          slot="picture"
          [appEditorId]="item.attributes.image.editorIds?.src"
          [picture]="imageToPicture(item.attributes.image.attributes, squareAspectRatio).sources"
          [alt]="item.attributes.image.attributes.alt"
          [rootColumns]="4"
          [variants]="pictureVariants"
        ></kb-picture>
      }

      <h3 slot="title" kb-heading [appEditorId]="item.editorIds?.headline">{{ item.attributes.headline }}</h3>

      <h3 kb-heading [appEditorId]="item.editorIds?.headline">{{ item.attributes.headline }}</h3>
      <kb-html [appEditorId]="item.editorIds?.text" [html]="item.attributes.text"></kb-html>
    </kb-flipping-tile>
  }
</kb-flipping-tiles>

@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
